import React, { useEffect, useState } from 'react';
import mermaid from 'mermaid';
import { nanoid } from 'nanoid';

let mermaidReady = false;
let renderQueue: Promise<void> = Promise.resolve();

function ensureMermaid(): void {
  if (mermaidReady) return;
  mermaid.initialize({
    startOnLoad: false,
    securityLevel: 'strict',
    suppressErrorRendering: true,
    fontFamily: 'inherit',
  });
  mermaidReady = true;
}

function enqueueRender(source: string): Promise<string> {
  const task = renderQueue.then(async () => {
    ensureMermaid();
    const id = `mmd${nanoid(8)}`;
    const { svg } = await mermaid.render(id, source);
    return svg;
  });
  renderQueue = task.then(
    () => undefined,
    () => undefined,
  );
  return task;
}

const MermaidDiagram: React.FC<{ source: string }> = ({ source }) => {
  const [svg, setSvg] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const timer = window.setTimeout(() => {
      const apply = (next: string) => {
        if (cancelled) return;
        setSvg(next);
        setFailed(false);
      };
      enqueueRender(source)
        .then(apply)
        .catch(() => {
          if (cancelled) return;
          enqueueRender(source)
            .then(apply)
            .catch(() => {
              if (!cancelled) setFailed(true);
            });
        });
    }, 200);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [source]);

  if (failed || !svg) {
    return (
      <pre>
        <code>{source}</code>
      </pre>
    );
  }

  return <div className="msg-mermaid" dangerouslySetInnerHTML={{ __html: svg }} />;
};

export default MermaidDiagram;
